import React, { useMemo } from "react";
import styled from "styled-components";
import {
  Ca100Package,
  PublicMetric,
} from "../../../models/CompanyprofileModels";
import { RowContainer } from "../../../components/containers/styledComponents";
import { CompassParagraph } from "../../../components/common/styledComponents";
import {
  fallbackRetrievePct,
  getBadgeColorsFromPercentage,
  getCA100Metric,
} from "./util";
import {
  AlignmentGrade,
  AlignmentGradeScoreMap,
  CA100_lobbyingMetrics,
} from "./CA100Constants";
import { ProgressBar } from "react-bootstrap";
import { compassLightGreyBackground } from "../../../styles";
import { CompassTag } from "../../../components/visuals/CompassTag";

const ParentProgressBar = styled(ProgressBar)`
  height: 14px;
  width: 85%;
  background-color: ${compassLightGreyBackground};
`;

const ScoreProgressBar = styled(ProgressBar)<{ color: string }>`
  background-color: ${({ color }): string => color};
`;

export const CA100Bar = ({
  metricsData,
  metricId,
}: {
  metricsData: PublicMetric[];
  metricId: CA100_lobbyingMetrics;
}): JSX.Element => {
  const { alignmentScore, metricName, value } = useMemo(() => {
    const { value, metricName } = getCA100Metric<CA100_lobbyingMetrics>(
      metricId,
      Ca100Package.LOBBYING,
      metricsData
    );
    return {
      alignmentScore:
        AlignmentGradeScoreMap[value as AlignmentGrade] ||
        fallbackRetrievePct(value),
      metricName,
      value,
    };
  }, [metricsData]);

  const { bg, text } = useMemo(
    () => getBadgeColorsFromPercentage(alignmentScore),
    [alignmentScore]
  );
  return (
    <>
      <RowContainer mt={4} mb={4}>
        <CompassParagraph>{metricName}</CompassParagraph>
      </RowContainer>
      <RowContainer mb={1}>
        <CompassTag
          tagKey={metricId}
          displayValue={value}
          bg={bg}
          color={text}
        />
      </RowContainer>
      <RowContainer>
        <ParentProgressBar>
          <ScoreProgressBar
            color={text}
            now={alignmentScore}
            min={0}
            max={100}
          />
        </ParentProgressBar>
      </RowContainer>
    </>
  );
};
